var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBoldLeft = function SvgIconArrowBoldLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.88,
    d: "m14.584 3.086 2.829 2.828L11.327 12l6.086 6.086-2.829 2.828L5.67 12z"
  })));
};
export { SvgIconArrowBoldLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNC41ODQxIDMuMDg1ODJMMTcuNDEyNSA1LjkxNDI1TDExLjMyNjkgMTJMMTcuNDEyNSAxOC4wODU4TDE0LjU4NDEgMjAuOTE0Mkw1LjY2OTkyIDEyTDE0LjU4NDEgMy4wODU4MloiIGZpbGwtb3BhY2l0eT0iMC44OCIvPgo8L3N2Zz4K";